import {Allowance} from "./allowance.dto";
import { PayrollCompanyDto } from "./company-account.dto";
import { EmployeeDto } from "./employee.dto";
import {PaginatorInfo} from "./generic.dto";
import { PayPeriodDto } from "./pay-period.dto";

export const BACKPAY_CATEGORY = {
  BASIC: 'BASIC',
  GROSS: 'GROSS',
  ALLOWANCES: 'ALLOWANCES',
  FIXED: 'FIXED',
  BASIC_DIFFERENCE: 'BASIC_DIFFERENCE',
  GROSS_DIFFERENCE: 'GROSS_DIFFERENCE'
};

export type BACKPAY_CATEGORY = keyof typeof BACKPAY_CATEGORY;

export type BackPayAllowance = {
  id: number
  backPayId: number
  allowanceId: number
  createdAt: string
}

export type BackPay = {
  id: number
  companyId: number
  code: string
  name: string
  description: string
  category: BACKPAY_CATEGORY
  fixedComponent:number| null
  rateComponent: number | null
  startPayPeriodId: number
  endPayPeriodId: number
  applicablePayPeriodId: number
  groupId: number | null
  createdAt: string
  modifiedAt: string | null
}

export class CreateBackPayDto {
  companyId!: number
  employeeIds!: number[]
  code!: string
  name!: string
  description!: string
  category!: BACKPAY_CATEGORY
  fixedComponent?: number
  rateComponent?: number
  startPayPeriodId!: number
  endPayPeriodId!: number
  applicablePayPeriodId!: number
  allowances?: number[]
  groupId?: number
}

export class UpdateBackPayDto {
  code?: string
  name?: string
  description?: string
  category?: BACKPAY_CATEGORY
  fixedComponent?: number
  rateComponent?: number
  startPayPeriodId?: number
  endPayPeriodId?: number
  applicablePayPeriodId?: number
  add?: number[]
  remove?: number[]
  addEmployeeIds?: number[]
  removeEmployeeIds?: number[]
  groupId?: number
}


export interface BackPayDto extends BackPay {
  backPayAllowances?: BackPayAllowanceDto[]
  employee?: EmployeeDto
  company?: PayrollCompanyDto
  startPayPeriod?: PayPeriodDto
  endPayPeriod?: PayPeriodDto
  group?: BackPayDto
}

export interface BackPayPaginator extends PaginatorInfo<BackPayDto> {}

export interface BackPayAllowanceDto extends BackPayAllowance {
  allowance?: Allowance
}


export class QueryBackPayDto {
  employeeId?: number;
  companyId?: number;
  code?: string
  category?: BACKPAY_CATEGORY
  groupId?: number
  page?: number = 1;
  limit?: number ;
  orderBy?: BackPayOrderBy = BackPayOrderBy.CREATED_AT_ASC;
}

export class SearchBackPayDto {
  q?: string;
  companyId?: number;
  page?: number = 1;
  limit?: number;
  orderBy: BackPayOrderBy = BackPayOrderBy.CREATED_AT_ASC;
}

export enum BackPayOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc',
  CODE_ASC = 'code:asc',
  CODE_DESC = 'code:desc',
  NAME_ASC = 'name:asc',
  NAME_DESC = 'name:desc'
}

export class UploadBackPaysResponse {
  successful!: {
    backPayId?: number;
    rowNumber?: number;
  }[];
  failed!: {
    rowNumber?: number;
    errors: {
      column: string;
      reason: string;
    }[]
  }[];
}

export interface QueryBackPayNoPaginationDto extends Omit<QueryBackPayDto, 'page' | 'limit'> {};


export class ExportBackPayQueryDto {
  backPayCode?: boolean;
  backPayName?: boolean;
  description?: boolean;
  category?: boolean;
  fixedComponent?: boolean;
  rateComponent?: boolean;
  startPayPeriodCode?: boolean;
  endPayPeriodCode?: boolean;
  applicablePayPeriodCode?: boolean;
  groupCode?: string;
  orderBy: BackPayOrderBy = BackPayOrderBy.CREATED_AT_ASC;
}